import { isEmpty, isEqual } from 'lodash'
import { useEffect, useState } from 'react'

import { MFilters } from 'types/filterTypes'
import { OptionsToSaveType } from './useUpdateSettings'

const useSelectedPreset = (presets: MFilters.PresetTypes<MFilters.FilterKey>, savedOptions: OptionsToSaveType) => {
  const [selectedPreset, setSelectedPreset] = useState('')

  // Get the preset matching the savedOptions to set the right button in "active" state
  useEffect(() => {
    if (isEmpty(presets)) return
    if (!isEqual(savedOptions, presets[selectedPreset])) setSelectedPreset('')
    Object.values(presets).forEach((preset, index) => {
      const presetWithUndefinedDates = { ...preset, rangeStart: undefined, rangeEnd: undefined }
      if (isEqual(preset, savedOptions) || isEqual(presetWithUndefinedDates, savedOptions)) setSelectedPreset(Object.keys(presets)[index])
    })
  }, [savedOptions, selectedPreset, presets])

  return selectedPreset
}

export default useSelectedPreset
